<!--
 * @Description: 会执行多次，第一次是layout content中引用，后面都是容器组件，如果容器组件不加就只会执行一次
 * @Date: 2021-03-22 01:16:13
-->
<template>
  <!-- key会影响路由加载，加上了key可以自己跳自己属于强制渲染但是不能使用缓存了，不加key可以加缓存但是不能自己跳自己 -->
  <router-view v-slot="{ Component }" class="router">
    <!-- <transition name="zoom-fade" mode="out-in" appear> -->
    <keep-alive :include="keepAliveComponents" :max="5">
      <component :is="Component" :key="forceRefreshKey" />
    </keep-alive>
    <!-- </transition> -->
  </router-view>
</template>

<script lang="ts" name="router-transition" setup>
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';

const keepAliveComponents = ref<any[]>([]);
const route = useRoute();
const routeQuery = route.query as {
  force?: number; // route: 重载标识，用于强制刷新组件
};

watch(
  () => route,
  to => {
    if (
      to.meta.keepAlive &&
      keepAliveComponents.value.indexOf(to.name) === -1
    ) {
      keepAliveComponents.value.push(to.name);
    }
    // TODO: 监听from，处理删除keepAliveComponents。
    // TODO: 不要了，写个hook处理数据放到query中，通过query处理回显参数
  },
  { deep: true, immediate: true }
);
// route: 处理缓存组件与重载组件
const forceRefreshKey = computed(() => {
  return route.fullPath + (routeQuery.force ? `_${routeQuery.force}` : '');
});
</script>
<style lang="scss" scoped>
.router {
  width: 100%;
  height: 100%;
  padding: 20px;
  position: relative;

  // 第一个元素是 tabs 顶部边距设置为 6px
  ::v-deep {
    &:has(> div > .xrk-tabs:first-child),
    &:has(> .xrk-tabs:first-child),
    &.xrk-tabs {
      padding-top: 12px !important;
    }

    &:has(> div > .xrk-radio-group:first-child),
    &:has(> .xrk-radio-group:first-child),
    &.xrk-radio-group {
      padding-top: 16px !important;
    }

    &:has(> .custom_xrk-table:last-child) {
      padding-bottom: 0;
    }
  }
}
</style>
